import { render, staticRenderFns } from "./CampaignInfo.vue?vue&type=template&id=39af87e5&scoped=true&"
import script from "./CampaignInfo.vue?vue&type=script&lang=ts&"
export * from "./CampaignInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignInfo.vue?vue&type=style&index=0&id=39af87e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39af87e5",
  null
  
)

export default component.exports